import { EMAIL_REGEX } from '@chilipiper/utils'

export const parseGuestFromSmartParameterId = (id?: string | null) => {
  const parsedEmailId = id?.replaceAll(' ', '+')
  const isEmailParam = EMAIL_REGEX.test(parsedEmailId ?? '')

  if (!id) {
    return
  }

  if (isEmailParam && parsedEmailId) {
    return {
      type: 'GuestEmailRequest' as const,
      guestEmail: parsedEmailId,
    }
  }

  return {
    type: 'CrmIdRequest' as const,
    crmId: id,
  }
}
